import Vue from "vue";
import Router, { Route } from "vue-router";
import Store from "@/store/index";
import { CGU_LINK } from "./utils/constants";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      redirect: () => {
        if (Store?.state?.currentUser?.isAdmin) {
          return {name: "admin"};
        } else {
          return {name: "keys"};
        }
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/r/:token",
      beforeEnter: async (to, from, next) => {
        const token = to?.params?.token;
        if (!token) {
          return router.replace({ name: "notFound" });
        }
        return Store.dispatch("public/shortUrls/getShortUrlObject", {token})
          .then((res) => {
            if (res.url.startsWith("http")) {
              window.location.href = res.url;
              return false;
            } else {
              return router.replace({ name: "notFound" });
            }
          })
          .catch((err) => {
            return router.replace({ name: "notFound" });
          });
      },
    },
    {
      path: "/index.html",
      name: "home_index_html", // having this as home, was a raising a warning duplicate route name
      redirect: {name: "keys"},
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/keys",
      name: "keys",
      components:  {
        default : () => import(/* webpackChunkName: "DESKTOP_KEYS" */"./views/front-office/keys.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_KEYS" */"./views/mobile/KeysMobile.vue"),
      },
      meta: {
        requiresAuth : true,
        canBeContextualized : true,
      },
    },
    {
      path: "/buildings",
      name: "buildings",
      components:  {
        default : () => import(/* webpackChunkName: "BUILDING" */"./views/front-office/buildings/List.vue"),
        mobile : () => import(/* webpackChunkName: "BUILDING" */"./views/front-office/buildings/ListMobile.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/buildings/:id",
      components: {
        default: () => import(/* webpackChunkName: "BUILDING" */"./views/DefaultWrapper.vue"),
        mobile: () => import(/* webpackChunkName: "BUILDING" */"./views/DefaultWrapper.vue"),
      },
      meta: {
        requiresAuth: true,
      },
      children: [{
        path: "",
        components: {
          default: () => import(/* webpackChunkName: "BUILDING" */"./views/front-office/buildings/Index.vue"),
          mobile: () => import(/* webpackChunkName: "BUILDING" */"./views/front-office/buildings/IndexMobile.vue"),
        },
        children: [{
          name: "building",
          path: "",
        }, {
          name: "building-keys",
          path: "keys",
          component: () => import(/* webpackChunkName: "BUILDING" */"./views/front-office/buildings/Keys.vue"),
        }, {
          name: "building-equipments",
          path: "equipments",
          component: () => import(/* webpackChunkName: "BUILDING" */"./components/buildings/Boxes.vue"),
        }, {
          name: "building-mission-orders",
          path: "mission-order",
          component: () => import(/* webpackChunkName: "BUILDING" */"./components/mission-orders/table.vue"),
        }, {
          name: "building-non-transferables",
          path: "non-transferables",
          component: () => import(/* webpackChunkName: "BUILDING" */"./components/buildings/NonTransferablesTab.vue"),
        }, {
          name: "building-logs",
          path: "logs",
          component: () => import(/* webpackChunkName: "BUILDING" */"./components/buildings/Logs.vue"),
        }, {
          name: "building-key-groups",
          path: "key-groups",
          component: () => import(/* webpackChunkName: "BUILDING" */"./views/front-office/KeyGroups.vue"),
        },
        {
          name: "building-orders",
          path: "orders",
          component: () => import(/* webpackChunkName: "BUILDING" */"./components/buildings/Orders.vue"),
        },
        ],
      }],
    },
    {
      path: "/mountings/:token",
      name: "mounting",
      components:  {
        default : () => import(/* webpackChunkName: "MOUNTINGS" */"./views/front-office/mountings/Index.vue"),
        mobile : () => import(/* webpackChunkName: "MOUNTINGS" */"./views/front-office/mountings/Index.vue"),
      },
    },
    {
      path: "/service-companies",
      name: "service-companies",
      components:  {
        default : () => import(/* webpackChunkName: "SERVICE_COMPANIES" */"./views/front-office/ServiceCompanies.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/mission-orders-created",
      name: "mission-orders-created",
      components:  {
        default : () => import(/* webpackChunkName: "MISSION_ORDERS_CREATED" */"./views/front-office/MissionOrdersCreated.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/mission-orders-assigned",
      name: "mission-orders-assigned",
      components:  {
        default : () => import(/* webpackChunkName: "MISSION_ORDERS_ASSIGNED" */"./views/front-office/MissionOrdersAssigned.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/key-groups/:id",
      components:  {
        default : () => import(/* webpackChunkName: "KEY_GROUP" */"./views/front-office/key-groups/Index.vue"),
        mobile : () => import(/* webpackChunkName: "KEY_GROUP" */"./views/front-office/key-groups/Index.vue"),
      },
      meta: {
        requiresAuth : true,
      },
      children: [
        {
          name: "key-group",
          path: "",
          redirect: "keys",
        },
        {
          name: "key-group-keys",
          path: "keys",
          component: () => import(/* webpackChunkName: "KEY_GROUP" */"./views/front-office/key-groups/Keys.vue"),
        },
        {
          name: "key-group-managers",
          path: "managers",
          component: () => import(/* webpackChunkName: "KEY_GROUP" */"./views/front-office/key-groups/Managers.vue"),
        },
        {
          name: "key-group-guests",
          path: "guests",
          component: () => import(/* webpackChunkName: "KEY_GROUP" */"./views/front-office/key-groups/Guests.vue"),
        },
        {
          name: "key-group-mission-orders",
          path: "mission-orders",
          component: () => import(/* webpackChunkName: "KEY_GROUP" */"./components/mission-orders/table.vue"),
        },
        {
          name: "key-group-non-transferables",
          path: "non-transferables",
          component: () => import(/* webpackChunkName: "KEY_GROUP" */"./views/front-office/key-groups/NonTransferables.vue"),
        },
      ],
    },
    {
      path: "/user-group/:id",
      name: "user-group",
      components:  {
        default : () => import(/* webpackChunkName: "DESKTOP_USER_GROUP" */"./views/front-office/userGroupPage.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_USER_GROUP" */"./views/front-office/userGroupPage.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/option-mail",
      name: "option-mail",
      components: {
        default: () => import(/* webpackChunkName: "PLANNING" */ "./views/front-office/OptionNotification.vue"),
      },
    },
    {
      path: "/keys/:id",
      components:  {
        default: () => import(/* webpackChunkName: "WRAPPER_KEYS" */"./views/DefaultWrapper.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_KEYS" */"./views/DefaultWrapper.vue"),
      },
      meta: {
        requiresAuth : true,
        canBeContextualized : true,
      },
      children: [
        {
          path: "",
          components:  {
            default : () => import(/* webpackChunkName: "DESKTOP_KEYS" */"./views/front-office/Key.vue"),
            mobile: () => import(/* webpackChunkName: "MOBILE_KEYS" */"./views/mobile/KeyMobile.vue"),
          },
          children: [
            {
              name: "key",
              path: "",
              redirect: "relays",
            },
            {
              name: "key-relays",
              path: "relays",
              component: () => import(/* webpackChunkName: "KEY" */"./components/keys/KeyRelaysTable.vue"),
            },
            {
              name: "key-managers",
              path: "managers",
              component: () => import(/* webpackChunkName: "KEY" */"./components/keys/managers/KeyManagersTab.vue"),
            },
            {
              name: "key-guests",
              path: "guests",
              component: () => import(/* webpackChunkName: "KEY" */"./components/keys/guests/KeyGuestsTab.vue"),
            },
            {
              name: "key-subkeys",
              path: "subkeys",
              component: () => import(/* webpackChunkName: "KEY" */"./components/keys/SubKeysTable.vue"),
            },
            {
              name: "key-logs",
              path: "logs",
              component: () => import(/* webpackChunkName: "KEY" */"./components/keys/KeyLogsTable.vue"),
            },
          ],
        }],
    },
    {
      path: "/relays",
      name: "relays",
      components: {
        default: () => import(/* webpackChunkName: "DESKTOP_RELAYS" */"./views/front-office/Relays.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_RELAYS" */"./views/mobile/RelaysMobile.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/contacts/:id",
      name: "user",
      components: {
        default: () => import(/* webpackChunkName: "DESKTOP_CONTACT" */"./views/front-office/User.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_CONTACT" */"./views/mobile/UserMobile.vue"),
      },
      meta: {
        requiresAuth : true,
      },
      children: [
        {
          path: "keys",
          name: "user-keys",
          component: () => import(/* webpackChunkName: "USER" */"./views/front-office/user/UserKeysTab.vue"),
        },
        {
          path: "key-access",
          name: "user-key-access",
          component: () => import(/* webpackChunkName: "USER" */"./views/front-office/user/UserKeyAccessTab.vue"),
        },
        {
          path: "key-holdings",
          name: "user-key-holdings",
          component: () => import(/* webpackChunkName: "USER" */"./views/front-office/user/UserKeyHoldingsTab.vue"),
        },
        {
          path: "logs",
          name: "user-logs",
          component: () => import(/* webpackChunkName: "USER" */"./views/front-office/user/UserLogsTab.vue"),
        },
      ],
    },
    {
      path: "/non-transferables/:id",
      components: {
        default: () => import(/* webpackChunkName: "DESKTOP_NON_TRANSFERABLE" */"./views/front-office/non-transferables/NonTransferablePage.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_NON_TRANSFERABLE" */"./views/front-office/non-transferables/NonTransferablePage.vue"),
      },
      meta: {
        requiresAuth : true,
      },
      children: [
        {
          name: "non-transferable",
          path: "",
        },
        {
          path: "guests",
          name: "non-transferable-guests",
          component: () => import(/* webpackChunkName: "NON_TRANSFERABLE" */"./views/front-office/non-transferables/NonTransferableGuestsTab.vue"),
        },
        {
          path: "logs",
          name: "non-transferable-logs",
          component: () => import(/* webpackChunkName: "NON_TRANSFERABLE" */"./views/front-office/non-transferables/NonTransferableLogsTab.vue"),
        },
      ],
    },
    {
      path: "/contacts",
      name: "contacts",
      components: {
        default: () => import(/* webpackChunkName: "DESKTOP_CONTACTS" */"./views/front-office/Users.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_CONTACTS" */"./views/mobile/UsersMobile.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/general-terms",
      name: "general-terms",
      beforeEnter() {
        window.location.href = CGU_LINK;
        },
    },
    {
      path: "/login",
      name: "login",
      meta: {
        requiresLogout: true,
        hideLayout: true,
      },
      components: {
        default: () => import(/* webpackChunkName: "login" */"./views/login.vue"),
        mobile: () => import(/* webpackChunkName: "login" */"./views/login.vue"),
      },
    },
    {
      path: "/login/:token",
      name: "login-without-account-and-type",
      meta: {
        requiresLogout: true,
      },
      components: {
        default: () => import(/* webpackChunkName: "DESKTOP_LOGIN_TOKEN" */"./views/login.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_LOGIN_TOKEN" */"./views/login.vue"),
      },
    },
    {
      path: "/login/:token/:type",
      name: "login-without-account",
      meta: {
        requiresLogout: true,
      },
      components: {
        default: () => import(/* webpackChunkName: "DESKTOP_LOGIN_TOKEN" */"./views/login.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_LOGIN_TOKEN" */"./views/login.vue"),
      },
    },
    {
      path: "/keys/import",
      name: "import-keys-preview",
      component: () => import("./views/b2b/import/PreviewKeys.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/boxes/import",
      name: "import-boxes-preview",
      component: () => import("./views/b2b/import/PreviewBoxes.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/buildings/import",
      name: "import-buildings-preview",
      component: () => import("./views/b2b/import/PreviewBuildings.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/keys/import/key-locations",
      name: "key-locations",
      component: () => import("./views/b2b/import/KeyLocations.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/keys/:keyId/give-hand-to-hand/:token",
      name: "key-hand-to-hand-scan",
      components: {
        default: () => import(/* webpackChunkName: "HAND_TO_HAND_SCAN" */"./views/front-office/HandToHand.vue"),
        mobile: () => import(/* webpackChunkName: "HAND_TO_HAND_SCAN" */"./views/front-office/HandToHand.vue"),
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/keys/keygroup/:keyGroupId/give-hand-to-hand/:token",
      name: "keyGroup-hand-to-hand-scan",
      components: {
        default: () => import(/* webpackChunkName: "HAND_TO_HAND_SCAN" */"./views/front-office/KeyGroupHandToHand.vue"),
        mobile: () => import(/* webpackChunkName: "HAND_TO_HAND_SCAN" */"./views/front-office/KeyGroupHandToHand.vue"),
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/management",
      name: "management",
      component: () => import("./views/front-office/Users.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/users/import",
      name: "import-users-preview",
      component: () => import("./views/b2b/import/PreviewUsers.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/create-company",
      name: "create-company",
      components: {
        default: () => import(/* webpackChunkName: "CreateCompany" */ "./views/CreateCompany.vue"),
        mobile: () => import(/* webpackChunkName: "CreateCompany" */ "./views/CreateCompany.vue"),
      },
      meta: {
        requiresLogout: true,
      },
    },
    {
      path: "/relays/:id",
      components: {
        default: () => import(/* webpackChunkName: "DESKTOP_RELAY" */"./views/front-office/Relay.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_RELAY" */"./views/mobile/RelayMobile.vue"),
      },
      children: [
        {
          path: "",
          name: "relay",
          redirect: {name: "relay-keys"},
        },
        {
          path: "keys",
          name: "relay-keys",
          component: () => import(/* webpackChunkName: "RELAY" */"./views/front-office/relays/relayKeys.vue"),
        },
        {
          path: "stats",
          name: "relay-stats",
          component: () => import(/* webpackChunkName: "RELAY" */"./views/front-office/relays/relayStats.vue"),
        },
        {
          path: "logs",
          name: "relay-logs",
          component: () => import(/* webpackChunkName: "RELAY" */"./views/front-office/relays/relayLogs.vue"),
        },
        {
          path: "alert",
          name: "relay-alert",
          component: () => import(
            /* webpackChunkName: "RELAY" */"./views/front-office/relays/relayAlertKeys.vue",
            ),
        },
      ],
    },
    {
      path: "/companies/:id/invoices",
      name: "companyInvoices",
      component: () => import(/* webpackChunkName: "INVOICES" */ "./views/front-office/Invoices.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/companies/:id/options",
      name: "companyOptions",
      component: () => import(/* webpackChunkName: "OPTIONS" */ "./views/front-office/Options.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/billing-activity",
      name: "billingActivity",
      component: () => import(/* webpackChunkName: "BILLING_ACTIVITY" */ "./views/front-office/BillingActivity.vue"),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/planning",
      name: "planning",
      components: {
        default: () => import(/* webpackChunkName: "PLANNING" */ "./views/front-office/Planning.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_PLANNING" */"./views/front-office/Planning.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/tutorials",
      name: "tutorials",
      components: {
        default: () => import(/* webpackChunkName: "tutorials" */ "./views/front-office/Tutorials.vue"),
        mobile: () => import(/* webpackChunkName: "tutorials" */"./views/front-office/Tutorials.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },

    {
      path: "/qr-code-reader",
      name: "qr-code-reader",
      components: {
        default: () => import(/* webpackChunkName: "QR_CODE_READER" */ "./views/front-office/QrCodeLocation.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_QR_CODE_READER" */"./views/front-office/QrCodeLocation.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/orders",
      name: "orders",
      components: {
        default: () => import(/* webpackChunkName: "orders" */ "./views/front-office/Order.vue"),
        mobile: () => import(/* webpackChunkName: "mobile_orders" */"./views/front-office/Order.vue"),
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta: {
        requiresAuth : true,
      },
      components: {
        default: () => import(/* webpackChunkName: "DASHBOARD" */ "./views/front-office/Dashboard.vue"),
        mobile: () => import(/* webpackChunkName: "MOBILE_DASHBOARD" */"./views/front-office/Dashboard.vue"),
      },
    },
    {
      path: "/transfers",
      name: "transfers",
      meta: {
        requiresAuth : true,
      },
      components: {
        default: () => import(/* webpackChunkName: "CreateCompany" */ "./views/front-office/Transfers.vue"),
        mobile: () => import(/* webpackChunkName: "CreateCompany" */ "./views/front-office/Transfers.vue"),
      },
    },
    {
      path: "/notifications",
      name: "notifications",
      meta: {
        requiresAuth : true,
      },
      components: {
        default: () => import(/* webpackChunkName: "Notifications" */ "./views/front-office/Notifications.vue"),
        mobile: () => import(/* webpackChunkName: "Notifications" */"./views/front-office/Notifications.vue"),
      },
    },
    {
      path: "/admin",
      meta: {
        requiresAuth : true,
        isAdmin: true,
      },
      components: {
        default: () => import(/* webpackChunkName: "bo" */"./views/back-office/AdminWrapper.vue"),
        mobile: () => import(/* webpackChunkName: "bo" */"./views/back-office/AdminWrapper.vue"),
      },
      children: [
        {
          path: "",
          name: "admin",
          redirect: {name: "admin-users"},
        },
        {
          path: "relays",
          name: "admin-relays",
          component: () => import(/* webpackChunkName: "relays" */"./views/front-office/Relays.vue"),
        },
        {
          path: "buildings",
          name: "admin-buildings",
          component: () => import(/* webpackChunkName: "relays" */"./views/back-office/Buildings.vue"),
        },
        {
          path: "companies",
          name: "companies",
          component: () => import(/* webpackChunkName: "boCompanies" */"./views/back-office/Companies.vue"),
        },
        {
          path: "create-company",
          name: "admin-create-company",
          components: {
            default: () => import(/* webpackChunkName: "CreateCompany" */ "./views/CreateCompany.vue"),
          },
        },
        {
          path: "keys",
          name: "admin-keys",
          component: () => import(/* webpackChunkName: "boKeys" */"./views/back-office/Keys.vue"),
        },
        // Edit a company
        {
          path: "companies/:id",
          name: "company-edit",
          component: () => import(/* webpackChunkName: "boCompany" */"./views/back-office/Company.vue"),
        },
        {
          path: "users",
          name: "admin-users",
          component: () => import(/* webpackChunkName: "boUsers" */"./views/back-office/users.vue"),
        },
        {
          path: "relay/:id",
          name: "admin-relay",
          component: () => import(/* webpackChunkName: "boRelay" */"./views/front-office/Relay.vue"),
        },
        {
          path: "logs",
          name: "admin-logs",
          component: () => import(/* webpackChunkName: "boLogs" */"./views/back-office/logs.vue"),
        },
        {
          path: "blockchain",
          name: "admin-blockchain",
          component: () => import(/* webpackChunkName: "blockchain" */"./views/back-office/Blockchain.vue"),
        },
        {
          path: "api-queries",
          name: "admin-api-queries",
          component: () => import(/* webpackChunkName: "api-queries" */"./views/back-office/ApiQueries.vue"),
          children: [
            {
              path: ":id",
              name: "admin-api-query",
              component: () => import("./views/back-office/ApiQueryModal.vue"),
            },
          ],
        },
        {
          path: "administration",
          name: "admin-administration",
          component: () => import(/* webpackChunkName: "administration" */"./views/back-office/Administration.vue"),
        },
        {
          path: "sql",
          name: "sql",
          component: () => import(/* webpackChunkName: "sql" */"./views/back-office/Sql.vue"),
        },
        {
          path: "sav",
          name: "sav",
          component: () => import(/* webpackChunkName: "sav" */"./views/back-office/Sav.vue"),
        },
        {
          path: "test-qrcode-scanner",
          name: "test-qrcode-scanner",
          components: {
            default: () => import(/* webpackChunkName: "test-qrcode-scanner" */ "./views/back-office/TestQRCodeScanner.vue"),
            mobile: () => import(/* webpackChunkName: "test-qrcode-scanner" */"./views/back-office/TestQRCodeScanner.vue"),
          },
        },
      ],
    },
    {
      path: "/email/validate/:token",
      name: "email-validate",
      meta: {
        requiresLogout: true,
      },
      components:  {
        default: () => import(/* webpackChunkName: "accountValidate" */"./views/AccountValidation.vue"),
        mobile: () => import(/* webpackChunkName: "accountValidate" */"./views/AccountValidation.vue"),
      },
    },
    {
      path: "/email/password/:token",
      name: "email-password",
      meta: {
        requiresLogout: true,
      },
      components:  {
        default: () => import(/* webpackChunkName: "password" */"./views/Password.vue"),
        mobile: () => import(/* webpackChunkName: "password" */"./views/Password.vue"),
      },
    },
    {
      path: "/nfc-test-page",
      name: "nfc-test-page",
      components:  {
        default: () => import(/* webpackChunkName: "password" */"./views/NfcTestPage.vue"),
        mobile: () => import(/* webpackChunkName: "password" */"./views/NfcTestPage.vue"),
      },
    },
    {
      path: "/key-access",
      name: "key-access",
      components:  {
        default: () => import(/* webpackChunkName: "keyAccess" */"./views/KeyAccess.vue"),
        mobile: () => import(/* webpackChunkName: "keyAccess" */"./views/KeyAccess.vue"),
      },
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: "/connected-box/:id/update-battery",
      name: "connected-box-update-battery",
      components:  {
        default: () => import(/* webpackChunkName: "WRAPPER_KEYS" */"./views/BoxBatteryConfirmation.vue"),
        mobile: () => import(/* webpackChunkName: "WRAPPER_KEYS" */"./views/BoxBatteryConfirmation.vue"),
      },
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/moqups",
      meta: {
        isAdmin: true,
      },
      components:  {
        default: () => import(/* webpackChunkName: "WRAPPER_KEYS" */"./views/DefaultWrapper.vue"),
      },
      children: [
        {
          path: "batiment",
          components: {
            default: () => import(/* webpackChunkName: "MOQUPS" */"./views/moqups/Batiment.vue"),
          },
        },
        {
          path: "organigramme",
          components: {
            default: () => import(/* webpackChunkName: "MOQUPS" */"./views/moqups/Organigramme.vue"),
          },
        },
        {
          path: "groupe-canon",
          components: {
            default: () => import(/* webpackChunkName: "MOQUPS" */"./views/moqups/GroupeCanon.vue"),
          },
        },
        {
          path: "groupe-cle",
          components: {
            default: () => import(/* webpackChunkName: "MOQUPS" */"./views/moqups/GroupeCle.vue"),
          },
        },
        {
          path: "lot",
          components: {
            default: () => import(/* webpackChunkName: "MOQUPS" */"./views/moqups/Lot.vue"),
          },
        },
      ],
    },
    {
      path: "/*",
      name: "notFound",
      components:  {
        default : () => import(/* webpackChunkName: "NOT_FOUND" */"./views/notFound.vue"),
        mobile: () => import(/* webpackChunkName: "NOT_FOUND" */"./views/notFound.vue"),
      },
    },
  ],
});

const isRouteInNav = (route: string): boolean => !!(Store.state.isMobile
  ? Store.getters["nav/getMobileNavItemList"].find((navItem) => navItem.name === route)
  : Store.getters["nav/getDefaultNavItemList"].find((navItem) => navItem.name === route));

// Middleware to get current user
router.beforeEach(async (to: Route, from: Route, next: any) => {

  // tslint:disable-next-line:no-console
  console.log("router", to.name);

  // for auth page
  if (to.matched.some((record) => record.meta.requiresAuth)) {

    // check token
    const token = to.query.token as string | undefined;
    if (token) {
      await Store.dispatch("auth/loginWithToken", { token });
    }
    // check user session
    if (!Store.state.currentUser?.id) {

      await Store.dispatch("auth/getConnectedUser")
        .then((user) => Store.dispatch("auth/afterLogin", { user }))
        .catch((err) => null);
    }

    // if still not connected return login
    if (!Store.state.currentUser?.id) {
      next({ name: "login" });
    }

    // Control on admin page
    if (to.matched.some((record) => record.meta.isAdmin) && !Store.state.currentUser.isAdmin) {
      next({ name: "home" });
    }

    // communicate
    await Store.dispatch("auth/communicate");
    // notification
    if (store.getters["oauth/getAccessToken"]) {
      await Store.dispatch("notifications/refetchNotifications");
    }

    // If we try to redirect users to /keys, check he can access this page
    if (to.name === "keys" && !isRouteInNav("keys") && isRouteInNav("key-access")) {
      return router.push({ name: "key-access" });
    } else if (to.name === "planning" && !isRouteInNav("planning")) {
      return router.push({ name: "home" });
    }
  }

  next();
});

router.beforeResolve((to: Route, from: Route, next: any) => {
  // If the page is not a contextualized page, remove context
  const context = Store.state.context.context;
  // Check if any of the parents route can be contextualized
  const canBeContextualized = to.matched.some((r) => r.meta.canBeContextualized);
  if (context && !canBeContextualized) {
    Store.commit("context/mutateContext", null);
  }
  next();
});

export default router;
